export const FLOOR_VIEW_SET = 'FLOOR_VIEW_SET';
export const FLOOR_PREV_PAGE = 'FLOOR_PREV_PAGE';